import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

class Selector extends React.Component {
    state = {
        id: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        if (props.forecast && (props.forecast !== state.forecast || props.id !== state.id)) {
            state.forecast = props.forecast;
            state.id = props.id;
            state.index = props.index ? props.index : -1;

            return state;
        }
        return null;
    }

    handleClick = (index) => {
        this.props.onChange('index', index);
        this.setState({ index: index });
    };

    renderChip = (index, id, text) => {
        return;
    };

    render() {
        const { index, forecast } = this.state;
        const { intl } = this.props;

        return (
            <Card className={'production_total_card'}>
                <CardContent>
                    <div className={'flex_full_row margin_top_8'}>
                        <div
                            onClick={(event) => this.handleClick(-1)}
                            className={
                                'hand barlow_regular_title c_white borderRadius24 padding_borders_flat center margin_right_12 uppercase ' +
                                (index === -1 ? 'bg_bluish' : 'bg_cool_grey')
                            }
                        >
                            {intl.formatMessage({ id: 'sales' })}
                        </div>
                        {forecast &&
                            forecast.productos &&
                            Object.keys(forecast.productos).map((i) => {
                                const producto = forecast.productos[i];
                                return (
                                    <div
                                        key={`selector-id-${producto.idProducto}`}
                                        onClick={(event) => this.handleClick(producto.idProducto)}
                                        className={
                                            'hand barlow_regular_title c_white borderRadius24 padding_borders_flat center margin_right_12 uppercase ' +
                                            (index === producto.idProducto
                                                ? 'bg_bluish'
                                                : 'bg_cool_grey')
                                        }
                                    >
                                        {producto.nProducto}
                                    </div>
                                );
                            })}
                    </div>
                </CardContent>
            </Card>
        );
    }
}

Selector.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Selector);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/forecast/Selector.js